export const GET_LIST_CHITIETCUAHANG = "GET_LIST_CHITIETCUAHANG";
export const GET_LIST_CHITIETCUAHANG_SUCCESS =
  "GET_LIST_CHITIETCUAHANG_SUCCESS";
export const GET_LIST_CHITIETCUAHANG_FAILURE =
  "GET_LIST_CHITIETCUAHANG_FAILURE";
